var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 37,
    viewBox: "0 0 126 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5B49FE",
    d: "M2.236 0h17.948a2.236 2.236 0 0 1 2.236 2.236v17.888a2.236 2.236 0 0 1-2.236 2.236H2.236A2.236 2.236 0 0 1 0 20.124V2.236A2.236 2.236 0 0 1 2.236 0z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BCC8A",
    d: "M15.697 13.425h17.948a2.236 2.236 0 0 1 2.236 2.236V33.55a2.236 2.236 0 0 1-2.236 2.236H15.697a2.236 2.236 0 0 1-2.236-2.236V15.661a2.236 2.236 0 0 1 2.236-2.236z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD348",
    d: "M2.236 13.425h17.948a2.236 2.236 0 0 1 2.236 2.236V33.55a2.236 2.236 0 0 1-2.236 2.236H2.236A2.236 2.236 0 0 1 0 33.55V15.661a2.236 2.236 0 0 1 2.236-2.236z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2280",
    d: "M15.697 0h17.948a2.236 2.236 0 0 1 2.236 2.236v17.888a2.236 2.236 0 0 1-2.236 2.236H15.697a2.236 2.236 0 0 1-2.236-2.236V2.236A2.236 2.236 0 0 1 15.697 0z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F3649",
    d: "M49.18 33.576V8.83h4.036l.285 2.408c1.345-1.947 3.692-2.797 5.679-2.797 5.396 0 8.981 4 8.981 9.134 0 5.098-3.23 9.134-8.838 9.134-1.845 0-4.578-.565-5.829-2.477v9.346l-4.314-.002zm14.66-16c0-2.727-1.844-4.958-4.97-4.958-3.125 0-4.97 2.236-4.97 4.957 0 2.721 2.018 4.957 4.97 4.957 2.953 0 4.97-2.231 4.97-4.957zM75.212 1.538v24.746h-4.296V1.538zM92.888 8.83h4.152v17.452h-4.08l-.213-2.549c-.993 2.053-3.726 3.046-5.68 3.08-5.183.035-9.014-3.151-9.014-9.276 0-6.02 4.01-9.168 9.122-9.134 2.343 0 4.579 1.098 5.574 2.833l.139-2.406zm-10.506 8.71c0 3.327 2.307 5.31 5.184 5.31 6.815 0 6.815-10.585 0-10.585-2.877 0-5.184 1.947-5.184 5.274zM105.419 3.91c0 3.355-5.112 3.355-5.112 0 0-3.353 5.112-3.362 5.112 0zm-4.722 4.85v17.524h4.331V8.761h-4.331zM121.608 26.284V17.15c0-2.654-1.455-4.673-4.224-4.673-2.661 0-4.473 2.236-4.473 4.886v8.921h-4.293V8.797h3.87l.284 2.37c1.776-1.735 3.55-2.62 5.751-2.62 4.118 0 7.419 3.078 7.419 8.568v9.167l-4.334.002z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e63f2dc0a58d8d16cd20d878ebf8e2d3.svg";
export { ForwardRef as ReactComponent };